import { createSelector } from 'reselect';
import { get } from 'lodash-es';
import type { State } from 'state/types';

export const getEventsStore = (state: State) => get(state, 'events', {});

export const getReceivedEvents = createSelector(getEventsStore, events =>
  get(events, 'receivedEvents', []),
);
